const ReportsIcon = () => {
  return (
    <svg
      className="animate-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 119 105"
      fill="none"
      shapeRendering="geometricPrecision"
      style={{
        position: 'absolute',
        width: '119px',
        height: '105px',
        bottom: -5,
        right: -4,
        transition: 'opacity 0.25s ease-in-out',
      }}
    >
      <rect
        className="animate-report-bg"
        x="16.28"
        y="18.08"
        width="101.86"
        height="85.42"
        rx="4"
        fill="#5bd992"
        stroke="#2d426a"
        strokeWidth={2}
      />
      <rect
        x="1"
        y="1"
        width="101.86"
        height="85.42"
        rx="4"
        fill="#fff"
        stroke="#2d426a"
        strokeWidth={2}
      />
      <line
        x1="15"
        y1="18"
        x2="45"
        y2="18"
        stroke="#2d426a"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M20.52 66.88 L38.5 50.79 L49.7 64.29 L81.53 32.46"
        fill="none"
        stroke="#2d426a"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="animate-report-chart"
        d="M20.52 66.88 L38.5 50.79 L49.7 64.29 L81.53 32.46"
        fill="none"
        stroke="#5bd992"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ReportsIcon;
